<app-header [dir]="dir" />
<div class="container py-5">
  <div class="row">
    <div class="border-top border-bottom py-2">
      <h1 class="text-center">
        {{ "translations.delivery_shipping" | translate }}
      </h1>
    </div>
    <div class="col-md-12" [dir]="dir">
      <div class="justify-content-center pt-5"
           [innerHtml]="PageContentHTML"></div>
    </div>
  </div>
</div>
<app-footer />

